var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotfound({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3000,
    height: 2000,
    viewBox: "0 0 3000 2000",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_583)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2598.39 1003.61C2488.12 924.165 2355.98 885.723 2234.33 828.177C2117.33 772.833 2034.08 683.912 1929.4 610.637C1758.36 490.904 1560.66 401.129 1359.47 346.338C1156.02 290.934 907.494 260.247 722.045 383.054C630.832 443.456 556.598 537.136 526.351 642.926C490.36 768.806 525.581 897.421 542.844 1023.22C556.871 1125.44 491.243 1181.83 413.919 1239.92C232.869 1375.92 237.898 1622.01 349.771 1798.41H2679.88C2818.24 1547.73 2879.09 1205.86 2598.39 1003.61Z",
    fill: "url(#paint0_linear_76_583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.402 1102.77C409.1 1102.77 447.767 1064.1 447.767 1016.4C447.767 968.705 409.1 930.039 361.402 930.039C313.704 930.039 275.037 968.705 275.037 1016.4C275.037 1064.1 313.704 1102.77 361.402 1102.77Z",
    fill: "url(#paint1_linear_76_583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2406.46 715.439C2476.96 715.439 2534.12 658.282 2534.12 587.775C2534.12 517.268 2476.96 460.111 2406.46 460.111C2335.95 460.111 2278.79 517.268 2278.79 587.775C2278.79 658.282 2335.95 715.439 2406.46 715.439Z",
    fill: "url(#paint2_linear_76_583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.688 794.692C417.988 773.822 403.746 754.229 382.876 750.928C362.007 747.628 342.414 761.87 339.113 782.74C335.813 803.609 350.055 823.203 370.925 826.503C391.794 829.804 411.388 815.561 414.688 794.692Z",
    fill: "url(#paint3_linear_76_583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2520.09 845.281C2539.61 837.195 2548.88 814.815 2540.8 795.293C2532.71 775.772 2510.33 766.502 2490.81 774.588C2471.29 782.674 2462.02 805.055 2470.1 824.576C2478.19 844.097 2500.57 853.367 2520.09 845.281Z",
    fill: "url(#paint4_linear_76_583)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.141 1792.47C161.332 1697.93 160.314 1532.52 208.459 1410.52C262.067 1274.69 387.724 1162.87 553.212 1103.75C557.232 1102.32 561.249 1100.91 565.275 1099.51L566.766 1103.81C562.753 1105.2 558.745 1106.61 554.739 1108.03C390.487 1166.71 265.813 1277.58 212.687 1412.19C165.134 1532.68 165.989 1695.93 275.093 1789.01L272.141 1792.47Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2604.37 1797.76L2600.33 1795.68C2682.17 1636.61 2730.64 1476.19 2740.51 1331.76C2750.23 1189.38 2721.99 1071.94 2658.83 992.147C2601.51 919.733 2487.45 844.774 2269.56 898.908L2268.47 894.496C2488.69 839.785 2604.24 915.865 2662.39 989.327C2726.27 1070.02 2754.85 1188.54 2745.04 1332.07C2735.13 1477.11 2686.49 1638.14 2604.37 1797.76Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M782.551 526.049L778.147 524.921C778.453 523.727 785.924 495.237 810.902 457.57C833.914 422.872 876.755 373.744 950.18 336.738C1034.27 294.359 1140.11 276.381 1264.76 283.292C1420.74 291.948 1606.74 339.843 1817.59 425.651L1815.88 429.859C1605.49 344.244 1419.98 296.458 1264.5 287.831C1140.64 280.953 1035.59 298.78 952.227 340.797C879.691 377.352 837.399 425.842 814.691 460.082C790.133 497.113 782.625 525.765 782.551 526.049Z",
    fill: "#DADADA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2387.43 558.304V1701.96C2387.43 1717.92 2374.47 1730.87 2358.52 1730.87H733.123C717.168 1730.87 704.213 1717.92 704.213 1701.96V558.304C704.213 542.349 717.168 529.394 733.123 529.394H2358.52C2374.47 529.394 2387.43 542.349 2387.43 558.304Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336.29 624.981H755.336V1583.4H2336.29V624.981Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2338.57 1585.67H753.063V622.708H2338.57V1585.67ZM757.609 1581.12H2334.02V627.255H757.609V1581.12Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2336.29 565.385H755.336V624.981H2336.29V565.385Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2338.57 627.254H753.063V563.112H2338.57V627.254ZM757.609 622.708H2334.02V567.658H757.609V622.708Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M829.651 608.952C822.06 608.952 815.883 602.775 815.883 595.184C815.883 587.591 822.06 581.414 829.651 581.414C837.244 581.414 843.421 587.591 843.421 595.184C843.421 602.775 837.244 608.952 829.651 608.952ZM829.651 585.96C824.566 585.96 820.429 590.097 820.429 595.184C820.429 600.269 824.566 604.406 829.651 604.406C834.738 604.406 838.875 600.269 838.875 595.184C838.876 590.097 834.739 585.96 829.651 585.96Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M875.633 608.952C868.042 608.952 861.865 602.775 861.865 595.184C861.865 587.591 868.042 581.414 875.633 581.414C883.224 581.414 889.401 587.591 889.401 595.184C889.401 602.775 883.224 608.952 875.633 608.952ZM875.633 585.96C870.548 585.96 866.411 590.097 866.411 595.184C866.411 600.269 870.548 604.406 875.633 604.406C880.718 604.406 884.855 600.269 884.855 595.184C884.855 590.097 880.718 585.96 875.633 585.96Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M921.614 608.952C914.023 608.952 907.846 602.775 907.846 595.184C907.846 587.591 914.023 581.414 921.614 581.414C929.205 581.414 935.382 587.591 935.382 595.184C935.382 602.775 929.205 608.952 921.614 608.952ZM921.614 585.96C916.529 585.96 912.392 590.097 912.392 595.184C912.392 600.269 916.529 604.406 921.614 604.406C926.699 604.406 930.836 600.269 930.836 595.184C930.836 590.097 926.699 585.96 921.614 585.96Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2470.41 1712.83H621.218V1798.59H2470.41V1712.83Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2472.97 1801.14H618.665V1710.28H2472.97V1801.14ZM623.77 1796.04H2467.86V1715.38H623.77V1796.04Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1627.23 1672.1H1464.4C1454.24 1672.1 1445.93 1663.79 1445.93 1653.63V1642.59C1445.93 1632.43 1454.24 1624.12 1464.4 1624.12H1627.23C1637.39 1624.12 1645.7 1632.43 1645.7 1642.59V1653.63C1645.7 1663.79 1637.39 1672.1 1627.23 1672.1Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1624.71 1674.37H1466.92C1454.09 1674.37 1443.66 1663.94 1443.66 1651.11V1645.11C1443.66 1632.28 1454.09 1621.85 1466.92 1621.85H1624.71C1637.54 1621.85 1647.98 1632.28 1647.98 1645.11V1651.11C1647.98 1663.94 1637.54 1674.37 1624.71 1674.37ZM1466.92 1626.39C1456.6 1626.39 1448.2 1634.79 1448.2 1645.11V1651.11C1448.2 1661.43 1456.6 1669.83 1466.92 1669.83H1624.71C1635.03 1669.83 1643.43 1661.43 1643.43 1651.11V1645.11C1643.43 1634.79 1635.03 1626.39 1624.71 1626.39H1466.92Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2112.18 1047.54H979.452C938.518 1047.54 905.214 1014.24 905.214 973.301V968.34C905.214 927.406 938.518 894.102 979.452 894.102H2112.18C2153.11 894.102 2186.41 927.406 2186.41 968.34V973.301C2186.41 1014.24 2153.11 1047.54 2112.18 1047.54ZM979.452 898.648C941.024 898.648 909.76 929.912 909.76 968.341V973.302C909.76 1011.73 941.024 1043 979.452 1043H2112.18C2150.6 1043 2181.87 1011.73 2181.87 973.302V968.341C2181.87 929.913 2150.6 898.648 2112.18 898.648H979.452Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1113.92 998.557H976.951C964.383 998.557 954.099 988.274 954.099 975.705V965.935C954.099 953.367 964.382 943.083 976.951 943.083H1113.92C1126.49 943.083 1136.77 953.366 1136.77 965.935V975.705C1136.77 988.274 1126.49 998.557 1113.92 998.557Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1335.85 998.557H1216.12C1203.38 998.557 1192.96 988.138 1192.96 975.403V966.238C1192.96 953.503 1203.38 943.084 1216.12 943.084H1335.85C1348.58 943.084 1359 953.503 1359 966.238V975.403C1359 988.138 1348.58 998.557 1335.85 998.557Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1591.02 998.557H1429.69C1416.27 998.557 1405.28 987.573 1405.28 974.149V967.491C1405.28 954.067 1416.27 943.083 1429.69 943.083H1591.02C1604.44 943.083 1615.43 954.067 1615.43 967.491V974.149C1615.43 987.574 1604.44 998.557 1591.02 998.557Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1945.06 998.255H1705.34C1691.91 998.255 1680.93 987.272 1680.93 973.847V967.189C1680.93 953.765 1691.91 942.781 1705.34 942.781H1945.06C1958.49 942.781 1969.47 953.765 1969.47 967.189V973.847C1969.47 987.272 1958.49 998.255 1945.06 998.255Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1736.72 778.9H1354.91V818.881H1736.72V778.9Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1485.58 1290.92H1417.93V1420.47H1485.58V1290.92Z",
    fill: "#ADC3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1625.12 1213.86H1557.47V1420.47H1625.12V1213.86Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1764.66 1168.5H1697V1420.47H1764.66V1168.5Z",
    fill: "#ADC3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1904.19 1278.14H1836.54V1420.47H1904.19V1278.14Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2043.73 1195.92H1976.08V1420.47H2043.73V1195.92Z",
    fill: "#ADC3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2183.27 1110.62H2115.61V1420.47H2183.27V1110.62Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.16 1102.74H887.346V1127.12H1269.16V1102.74Z",
    fill: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1269.16 1171.19H887.346V1420.46H1269.16V1171.19Z",
    fill: "#E5ECFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.55 1263.85C1081.17 1258.17 1066.39 1262.63 1055.83 1272.95C1046.22 1282.35 1044.86 1295.63 1040.34 1307.49C1049.69 1310.05 1058.1 1315.59 1068.29 1314C1081.53 1311.93 1081.88 1299.58 1089.38 1291.17C1095.81 1283.96 1103.51 1279.31 1112.71 1278.07C1108.76 1272.26 1103.94 1267.16 1095.55 1263.85Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1203.69 1250.92C1190.67 1253.75 1176.99 1258.38 1167.7 1267.87C1159.72 1276.03 1160 1290.24 1154.2 1298.82C1160.75 1303.18 1168.12 1305.22 1175.31 1301.34C1182.34 1297.54 1186.61 1288.99 1194.18 1285.26C1200.28 1282.27 1209.03 1280.37 1215.66 1279.19C1217.18 1278.91 1218.74 1278.74 1220.29 1278.53V1248.23C1214.73 1248.86 1209.19 1249.72 1203.69 1250.92Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1215.66 1279.19C1209.03 1280.37 1200.28 1282.27 1194.18 1285.26C1186.6 1288.99 1182.34 1297.54 1175.31 1301.34C1168.12 1305.22 1160.75 1303.18 1154.2 1298.82C1151.62 1297.1 1149.16 1295.03 1146.9 1292.8C1137.94 1283.97 1135.14 1278.98 1120.97 1277.83C1118.08 1277.6 1115.34 1277.72 1112.71 1278.07C1103.51 1279.31 1095.81 1283.96 1089.38 1291.17C1081.88 1299.58 1081.53 1311.94 1068.29 1314C1058.1 1315.59 1049.69 1310.05 1040.34 1307.5C1036.61 1306.48 1032.73 1305.92 1028.52 1306.5C1018.66 1307.85 1012.43 1313.77 1005.55 1318.26C1000.76 1321.39 995.671 1323.83 988.821 1323.53C973.535 1322.85 953.821 1314.05 936.214 1313.48V1381.56H1220.29V1278.53C1218.74 1278.74 1217.18 1278.91 1215.66 1279.19Z",
    fill: "#ADC3FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1005.55 1318.26C1004.43 1317.29 1003.37 1316.23 1002.42 1315.05C995.387 1306.32 994.823 1295.24 987.039 1287.06C971.888 1271.13 951.195 1277.43 936.216 1290.98V1313.48C953.823 1314.04 973.537 1322.85 988.823 1323.52C995.672 1323.83 1000.76 1321.39 1005.55 1318.26Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M595.363 1156.17L522.771 1170.4L539.339 1063.65L583.976 1064.56C583.691 1066.44 583.407 1068.26 583.236 1070.14C581.585 1084.49 582.439 1098.89 584.261 1111.76C587.904 1137.04 595.363 1156.17 595.363 1156.17Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M584.26 1111.76C556.362 1098.61 546 1070.99 546 1070.99L583.235 1070.14C581.584 1084.49 582.439 1098.89 584.26 1111.76Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M599.614 1002.9C602.461 1012.86 618.592 1075.96 589.176 1083.08C559.76 1090.2 529.395 1063.15 529.395 1063.15L539.359 1002.42L582.06 989.615L599.614 1002.9Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M560.65 1037.24C560.65 1037.24 568.3 986.768 599.614 1002.9C598.496 1002.32 596.871 997.284 596.174 996.143C593.012 990.967 588.953 986.264 584.048 982.669C566.226 969.607 536.181 974.355 521.804 989.377C507.65 1004.17 507.217 1030.45 514.508 1049.56C515.687 1052.65 517.18 1055.61 518.968 1058.4C520.593 1060.92 522.519 1063.03 524.686 1065.11C526.548 1066.9 540.518 1077.9 540.664 1069.44C541.019 1048.8 560.65 1037.24 560.65 1037.24Z",
    fill: "#EB5D60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M567.55 1048.84C572.877 1044.48 572.82 1035.6 567.424 1029C562.027 1022.41 553.334 1020.59 548.008 1024.95C542.681 1029.3 542.738 1038.18 548.135 1044.78C553.531 1051.38 562.224 1053.2 567.55 1048.84Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.537 1045.95C609.198 1045.95 612.166 1042.73 612.166 1038.75C612.166 1034.78 609.198 1031.56 605.537 1031.56C601.876 1031.56 598.908 1034.78 598.908 1038.75C598.908 1042.73 601.876 1045.95 605.537 1045.95Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.416 1567.97L424.065 1604.98C424.065 1604.98 495.233 1786.22 516.109 1797.61C536.985 1809 526.547 1708.41 540.781 1678.05L558.81 1606.88L510.416 1567.97Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503.653 1670.98L503.022 1680.05L540.503 1682.66L541.134 1673.58L503.653 1670.98Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.591 1554.69L540.781 1678.05C540.781 1678.05 743.848 1571.77 794.14 1474.98L714.432 1370.6L488.591 1554.69Z",
    fill: "#7D69ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M760.929 1654.33C760.929 1654.33 855.82 1658.12 899.47 1583.16L802.681 1568.92L760.929 1654.33Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M909.354 1667.28L802.306 1705.1L793.669 1674.55L777.987 1619.23L867.216 1577L873.489 1590.46L909.354 1667.28Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1044.65 1798.56L927.463 1706.04L909.372 1667.3L802.315 1705.08L828.776 1798.56H1044.65Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M923.83 1703.32L899.633 1734.15L906.784 1739.76L930.981 1708.93L923.83 1703.32Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.489 1590.46L793.669 1674.55L777.987 1619.23L867.216 1577L873.489 1590.46Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M899.49 1583.14C849.034 1595.87 802.897 1619.64 760.942 1654.32L688.804 1464.55C688.804 1464.55 543.256 1603.28 456.345 1580.32C373.753 1558.5 409.799 1421.82 409.799 1421.82C523.21 1342.41 703.623 1235.77 782.67 1320.23C783.079 1320.59 783.397 1320.91 783.715 1321.27C799.897 1339.05 818.17 1374.18 835.352 1413.09C869.625 1490.59 899.49 1583.14 899.49 1583.14Z",
    fill: "#7D69ED"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M835.352 1413.09C756.714 1431.59 675.804 1344.23 675.804 1344.23L757.078 1317.55L782.669 1320.23C783.078 1320.59 783.396 1320.91 783.714 1321.27C799.897 1339.05 818.17 1374.18 835.352 1413.09Z",
    fill: "#5B4DAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.818 1655.13L687.903 1468.57C672.526 1483.19 588.847 1559.75 500.621 1583.01L499.462 1578.61C595.491 1553.3 686.295 1463.84 687.201 1462.94L689.685 1460.47L763.066 1653.52L758.818 1655.13Z",
    fill: "#5B4DAD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M526.755 1116.54L494.891 1219.54L452.026 1358.09C452.026 1358.09 420.753 1369.32 393.161 1365.82C368.797 1362.73 347.296 1348.09 353.115 1303.86C365.934 1206.36 526.755 1116.54 526.755 1116.54Z",
    fill: "#FBC343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.891 1219.54L452.026 1358.09C452.026 1358.09 420.753 1369.32 393.161 1365.82C416.298 1223.59 492.845 1163 492.845 1163L494.891 1219.54Z",
    fill: "#E49B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.488 1218.5L814.761 1308.86L734.668 1233.32L766.442 1180.04L809.397 1202.95L838.488 1218.5Z",
    fill: "#FBC343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M766.622 1180.14L797.018 1131.56L858.429 1105.38L838.307 1218.68L766.622 1180.14Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.99 1087.18C1048.86 1083.31 1034.31 1083.95 1021.17 1088.77C1012.49 1091.95 1004.4 1097 996.946 1103.81L967.263 1034.99C977.582 1033.18 986.991 1030.09 995.491 1025.59C1007.81 1019.09 1018.08 1009.68 1026.08 996.904L1064.99 1087.18Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M997.016 1103.76L967.358 1034.95L530.371 1242.39L546.163 1279.02L997.016 1103.76L967.358 1034.95L997.016 1103.76Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1064.99 1087.18C1048.86 1083.31 1034.31 1083.95 1021.17 1088.77L995.492 1025.59C1007.81 1019.09 1018.08 1009.68 1026.08 996.904L1064.99 1087.18Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1405.32 1123.18C1496.48 1032.02 1496.48 884.208 1405.32 793.043C1314.15 701.878 1166.34 701.878 1075.18 793.043C984.014 884.208 984.014 1032.02 1075.18 1123.18C1166.34 1214.35 1314.15 1214.35 1405.32 1123.18Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1377.77 1095.64C1453.72 1019.68 1453.72 896.541 1377.77 820.588C1301.82 744.636 1178.68 744.636 1102.72 820.588C1026.77 896.541 1026.77 1019.68 1102.72 1095.64C1178.68 1171.59 1301.82 1171.59 1377.77 1095.64Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1062.96 878.191H1417.51C1416.75 876.488 1415.98 874.783 1415.17 873.113H1065.39C1064.57 874.8 1063.73 876.481 1062.96 878.191Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1416.93 1039.4H1063.65C1064.43 1041.1 1065.18 1042.81 1066.01 1044.48H1414.48C1415.31 1042.8 1416.14 1041.11 1416.93 1039.4Z",
    fill: "#86A7FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1095.02 960.771V956.821C1095.02 940.869 1081.97 927.818 1066.02 927.818H1048.18C1044.96 948.078 1044.91 968.975 1048.36 989.774H1066.02C1081.97 989.774 1095.02 976.723 1095.02 960.771Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1187.16 927.818C1171 927.818 1157.78 941.042 1157.78 957.205V960.387C1157.78 976.55 1171 989.774 1187.16 989.774H1313.84C1330 989.774 1343.22 976.55 1343.22 960.387V957.205C1343.22 941.042 1330 927.818 1313.84 927.818H1187.16Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1432.42 927.818H1425.89C1408.85 927.818 1394.91 941.758 1394.91 958.796C1394.91 975.834 1408.85 989.774 1425.89 989.774H1432.13C1435.49 969.531 1435.71 948.634 1432.42 927.818Z",
    fill: "#D3DFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M838.488 1218.5L809.397 1202.95L827.125 1164.45C827.125 1164.45 851.806 1119.86 864.125 1121.77C876.444 1123.63 838.488 1218.5 838.488 1218.5Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M734.688 1233.31L728.647 1243.45C716.634 1226.94 690.159 1191.75 656.852 1163.8C626.904 1138.69 586.272 1099.63 550.802 1105.04C455.835 1119.45 409.813 1421.82 409.813 1421.82L655.542 1332.88L710.589 1375.76C722.562 1385.09 737.618 1389.55 752.74 1388.25C778.143 1386.06 799.408 1368.1 805.815 1343.42L814.779 1308.89L734.688 1233.31Z",
    fill: "#FBC343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M590.347 1272.04L587.333 1275.44L654.002 1334.52L657.016 1331.12L590.347 1272.04Z",
    fill: "#E49B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M723.878 1234.1L720.169 1236.72L760.321 1293.54L764.03 1290.92L723.878 1234.1Z",
    fill: "#E49B31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1979.11 646.464C1979.11 646.464 1967.61 682.447 1938.63 698.439C1909.64 714.431 1871.16 731.423 1884.15 736.92C1897.15 742.417 1931.88 738.919 1931.88 738.919C1931.88 738.919 1864.66 790.894 1883.65 796.391C1902.64 801.888 1948.62 764.406 1948.62 764.406C1948.62 764.406 1942.37 778.399 1951.87 781.398C1961.37 784.396 1979.61 780.898 1979.61 780.898C1979.61 780.898 1977.11 790.893 1996.1 788.394C2015.09 785.895 2064.57 725.924 2064.57 725.924L2068.06 670.95L1979.11 646.464Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.63 337.612C1920.63 337.612 1995.6 318.121 2108.04 388.587C2209.23 451.999 2215.99 514.526 2168.01 592.489C2120.04 670.451 2064.56 725.925 2064.56 725.925L1979.11 646.463L2054.07 529.519L1920.63 337.612Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1894.15 349.607C1894.15 349.607 1788.2 406.58 1734.22 529.52H2104.05L2002.1 367.598L1894.15 349.607Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1789.82 529.02C1789.82 529.02 1826.18 535.392 1838.92 529.02C1851.67 522.648 1811.19 504.282 1776.33 495.661C1741.47 487.04 1700.61 471.673 1666.88 519.649C1633.15 567.626 1636.52 570.999 1647.39 570.25C1658.26 569.5 1684.12 537.266 1684.12 537.266C1684.12 537.266 1656.39 572.124 1669.5 575.872C1682.62 579.62 1714.11 532.018 1714.11 532.018C1714.11 532.018 1687.12 570.624 1700.99 575.122C1714.86 579.62 1744.84 532.393 1744.84 532.393C1744.84 532.393 1714.48 579.995 1732.85 578.871C1744.8 578.139 1758.5 557.255 1766.61 542.752C1771.32 534.317 1780.16 529.02 1789.82 529.02Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1920.02 401.947C1905.62 401.947 1894.25 395.768 1894.03 395.648L1896.25 391.68C1897.75 392.51 1933.34 411.74 1956.3 375.959L1960.13 378.414C1948.19 397.011 1932.89 401.947 1920.02 401.947Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1981.01 647.704L1977.2 645.223L2073.88 496.687L2036.8 438.831L2040.62 436.376L2079.3 496.705L1981.01 647.704Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1941.82 354.334C1935.72 376.074 1906.63 380.641 1893.23 362.474L1889.65 357.66L1866.57 326.39L1890.35 295.467L1892.63 292.489L1898.04 296.509L1901.96 299.438L1943.51 330.51C1944.35 340.138 1943.61 347.981 1941.82 354.334Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1889.65 357.66L1866.57 326.39L1890.35 295.467L1898.04 296.509L1901.72 297.005C1901.72 297.005 1901.81 297.849 1901.96 299.437C1902.56 307.479 1903.35 334.083 1889.65 357.66Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1800.81 277.168C1800.81 277.168 1852.28 369.615 1889.32 330.94C1917.45 301.572 1897.6 261.037 1897.6 261.037L1870.3 234.565L1809.49 252.765L1800.81 277.168Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1880.22 281.718C1880.22 281.718 1862.85 254.108 1843.93 267.138C1825 280.167 1802.77 315.222 1776.82 294.954C1758.75 280.848 1771.03 240.769 1794.91 244.181C1794.91 244.181 1821.28 193.615 1866.57 206.954C1911.87 220.294 1894.49 247.283 1918.69 251.316C1942.89 255.349 2021.25 260.976 2008.22 343.805C2008.22 343.805 1974.69 334.856 1946.71 337.981C1911.73 341.887 1888.08 284.199 1888.08 284.199C1885.81 284.82 1880.22 281.718 1880.22 281.718Z",
    fill: "#FBC343"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1884.57 297.229C1892.1 297.229 1898.22 289.312 1898.22 279.546C1898.22 269.78 1892.1 261.863 1884.57 261.863C1877.03 261.863 1870.92 269.78 1870.92 279.546C1870.92 289.312 1877.03 297.229 1884.57 297.229Z",
    fill: "#E28B6D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2864.48 1795H123.519V1801.82H2864.48V1795Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2415.61 1549.37H2228.11V1658.46H2415.61V1549.37Z",
    fill: "#1F3C88"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2437.43 1798.2L2537.34 1848.38L2503.35 1718.45L2459.41 1710L2413.4 1726.44L2437.43 1798.2Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2459.43 1710.01L2437.43 1798.19C2437.43 1798.19 2342.56 1785.69 2249.61 1765.05C2206.74 1755.6 2164.29 1744.37 2131.74 1731.83C2114.6 1725.24 2100.19 1718.28 2089.92 1711.05C2017.69 1660.14 2043.47 1542.91 2165.97 1562.96C2213.42 1570.73 2264.61 1591.87 2310.79 1615.82C2331.84 1626.69 2351.79 1638.19 2369.88 1649.23C2422.7 1681.42 2459.43 1710.01 2459.43 1710.01Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M2369.88 1649.23L2249.61 1765.05C2206.74 1755.6 2164.29 1744.37 2131.74 1731.83L2310.79 1615.82C2331.84 1626.69 2351.79 1638.19 2369.88 1649.23Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2122.54 1725.94L2001.59 1796.16L2179.58 1795.42L2191 1727.94L2122.54 1725.94Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2228.49 1710.45L2191 1727.94L2179.58 1795.42L2182.01 1795.41L2256.47 1796.41L2282.46 1763.93L2228.49 1710.45Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2228.49 1710.45C2228.49 1710.45 2370.42 1571.52 2493.36 1538.53C2607.34 1507.95 2641.29 1622.49 2577.32 1679.47C2513.35 1736.44 2256.47 1796.41 2256.47 1796.41L2228.49 1710.45Z",
    fill: "#3A6BEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2257.02 1798.61L2255.92 1794.21C2344.07 1771.94 2434.64 1747.78 2500 1721.88L2501.68 1726.11C2436.08 1752.1 2345.33 1776.31 2257.02 1798.61Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2314.25 1163.94C2301.48 1164.98 2289.44 1168.13 2278.81 1175.69C2269.94 1182 2263.14 1190.74 2258.77 1200.68C2252 1216.11 2253.57 1233.34 2248.38 1249.15C2243.38 1264.37 2231.13 1272.22 2219.73 1282.39C2208.75 1292.18 2200.85 1308.38 2204.76 1323.26C2205.85 1327.38 2207.86 1331.21 2210.52 1334.54C2212.56 1337.09 2218.78 1344.44 2222.28 1344.46C2222.29 1344.46 2415.33 1345.31 2415.33 1345.31C2415.33 1345.31 2451.2 1311.71 2409.92 1272.42C2398.46 1261.52 2385.63 1250.31 2379.8 1234.99C2376.2 1225.53 2374.39 1215.55 2371.68 1205.84C2368.22 1193.46 2360.6 1180.81 2350.32 1172.95C2339.97 1165.03 2326.99 1162.9 2314.25 1163.94Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2298.02 1175.62C2298.02 1175.62 2265.84 1151.13 2297.73 1140.03C2322.12 1131.53 2345 1141.16 2330.48 1172.77L2298.02 1175.62Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2306.45 1298.4C2306.45 1298.4 2125.03 1329.13 2089.05 1454.32C2053.07 1579.51 2272.05 1587.63 2272.05 1587.63C2272.05 1587.63 2487.11 1580.26 2525.34 1545.78C2563.57 1511.3 2583.06 1336.63 2327.44 1299.9L2306.45 1298.4Z",
    fill: "#EB5D60"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2318.14 1366.87C2316.97 1366.87 2315.79 1366.82 2314.63 1366.73C2301.59 1365.66 2291.26 1358.93 2285.55 1347.75L2289.6 1345.68C2294.57 1355.4 2303.59 1361.27 2314.99 1362.19C2328.97 1363.37 2344.03 1356.87 2351.66 1346.51L2355.32 1349.2C2347.45 1359.9 2332.55 1366.87 2318.14 1366.87Z",
    fill: "#AB4446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2153.51 1443.06L2150.65 1446.59L2245.54 1523.3L2248.4 1519.77L2153.51 1443.06Z",
    fill: "#AB4446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2478.95 1444.94L2392.45 1519.82L2395.42 1523.26L2481.92 1448.38L2478.95 1444.94Z",
    fill: "#AB4446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2410.86 1596.01H2222.03C2215.69 1596.01 2210.54 1590.86 2210.54 1584.51V1452.83C2210.54 1446.48 2215.69 1441.33 2222.03 1441.33H2410.86C2417.21 1441.33 2422.35 1446.48 2422.35 1452.83V1584.51C2422.35 1590.86 2417.21 1596.01 2410.86 1596.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2296.49 1259.62L2291.56 1306.59C2290.61 1315.6 2294.19 1324.49 2301.04 1330.17C2310.41 1337.95 2323.75 1338.04 2333.22 1330.38L2333.65 1330.03C2340.85 1324.21 2344.52 1314.9 2343.3 1305.56L2337.2 1258.79L2296.49 1259.62Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2295.6 1269.29C2309.98 1297.48 2326.21 1298.05 2338.59 1270L2313.11 1266.73L2295.6 1269.29Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2317.47 1279.54C2336.46 1279.54 2351.85 1259.4 2351.85 1234.55C2351.85 1209.71 2336.46 1189.57 2317.47 1189.57C2298.48 1189.57 2283.09 1209.71 2283.09 1234.55C2283.09 1259.4 2298.48 1279.54 2317.47 1279.54Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2357.53 1227.15C2357.53 1227.15 2323.08 1226.58 2311.69 1198.68C2311.69 1198.68 2293.18 1205.23 2288.34 1229.14L2275.24 1233.7L2274.96 1196.12L2304 1177.61L2329.91 1178.18L2352.69 1197.26L2357.53 1227.15Z",
    fill: "#102048"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2293.16 1230.93C2297 1238.33 2295.02 1246.97 2288.74 1250.23C2282.45 1253.49 2274.25 1250.13 2270.42 1242.73C2266.58 1235.33 2268.56 1226.69 2274.84 1223.43C2281.12 1220.18 2289.33 1223.53 2293.16 1230.93Z",
    fill: "#F9B384"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2343.02 1230.93C2339.18 1238.33 2341.17 1246.97 2347.45 1250.23C2353.73 1253.49 2361.93 1250.13 2365.77 1242.73C2369.61 1235.33 2367.62 1226.69 2361.34 1223.43C2355.06 1220.18 2346.86 1223.53 2343.02 1230.93Z",
    fill: "#F9B384"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_76_583",
    x1: 1533.62,
    y1: 297.848,
    x2: 1533.62,
    y2: 1798.41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C98BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_76_583",
    x1: 361.402,
    y1: 930.039,
    x2: 361.402,
    y2: 1102.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C98BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_76_583",
    x1: 2406.46,
    y1: 460.111,
    x2: 2406.46,
    y2: 715.439,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C98BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_76_583",
    x1: 339.113,
    y1: 782.74,
    x2: 414.688,
    y2: 794.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C98BC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_76_583",
    x1: 2490.81,
    y1: 774.588,
    x2: 2520.09,
    y2: 845.281,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#60E8D3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C98BC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_583"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 3000,
    height: 2000,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotfound);
export default __webpack_public_path__ + "static/media/notfound.c370e7ca68cab49eb37d712b40a74040.svg";
export { ForwardRef as ReactComponent };